import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 6h12v12H6z"
}), 'Stop');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Stop.js
// module id = 6503
// module chunks = 2